import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Login from "../views/login/Login.vue"

const routes: Array<RouteRecordRaw> = [
  {
    path:"/mine",
    name:"Mine",
    component: () => import("../layout/Mine.vue"),
    children: [
      
      {
        path:"archives",
        name: "Archives",
        component: () => import("../views/mine/Archives.vue")
      },
      {
        path:"webcast",
        name: "Webcast",
        component: () => import("../views/mine/ReleaseWebcast.vue")
      },
      {
        path:"video",
        name: "Video",
        component: () => import("../views/mine/ReleaseVideo.vue")
      },
      {
        path:"wallet",
        name: "Wallet",
        component: () => import("../views/mine/Wallet.vue")
      },
      {
        path:"transaction",
        name: "Transaction",
        component: () => import("../views/mine/Transaction.vue")
      },
      {
        path:"transactionxq",
        name: "Transactiondetail",
        component: () => import("../views/mine/Transactiondetail.vue")
      },
      {
        path:"cashoutxq",
        name: "Cashoutdetail",
        component: () => import("../views/mine/Cashoutdetail.vue")
      },
      {
        path:"cashout",
        name: "Cashout",
        component: () => import("../views/mine/Cashout.vue")
      },
      {
        path:"addaccount",
        name: "Addaccount",
        component: () => import("../views/mine/Addaccount.vue")
      },
      {
        path:"liststatistic",
        name: "Liststatistic",
        component: () => import("../views/mine/Liststatistic.vue")
      },
      {
        path:"aboutus",
        name: "Aboutus",
        component: () => import("../views/mine/Aboutus.vue")
      }
    ]
  },
  {
    path:"/regime",
    name:"Regime",
    component: () => import("../layout/Regime.vue"),
    children: [
      {
        path: "video",
        component: () => import("../views/regime/Video.vue")
      },
      {
        path: "videoinfo",
        component: () => import("../views/regime/VideoInfo.vue")
      },
      {
        path: "subscriber",
        component: () => import("../views/regime/Subscriber.vue")
      },
      {
        path: "studentlist",
        component: () => import("../views/regime/SignupStu.vue")
      },
      {
        path: "live",
        component: () => import("../views/regime/Live.vue")
      },
      {
        path: "livedetail",
        component: () => import("../views/regime/Livedetail.vue")
      },
      
      {
        path: "liveing",
        component: () => import("../views/regime/Liveing.vue")
      },
      {
        path: "date",
        component: () => import("../views/regime/date.vue")
      },
      {
        path: "week",
        component: () => import("../views/regime/week.vue")
      }
    ]
  },
  {
    path:"/live",
    name:"live",
    component: () => import("../layout/Live.vue"),
    children:[
      {
        path: "liveing",
        component: () => import("../views/regime/Liveing.vue")
      },
    ]
  },
  {
    path: '/',
    name: 'Login',
    component:Login
  },
  {
    path: '/sign',
    name: 'Sign',
    component: () => import('../views/login/Sign.vue')
  },
  {
    path: '/reset',
    name: 'Reset',
    component: () => import('../views/login/Reset.vue')
  },
  {
    path: '/share',
    name: 'Share',
    component: () => import('../views/login/Share.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/login/About.vue')
  },{
    path: '/wblogin',
    name: 'Wblogin',
    component: () => import('../views/login/wblogin.vue')
  },{
    path: '/wxlogin',
    name: 'Wxlogin',
    component: () => import('../views/login/wxlogin.vue')
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
